import React from 'react'
import { ReactSVG } from 'react-svg'

/*
    {
        icon: object,
        size: string,
        classes: string
    }
*/

function Icon ({ model }) {
  // Push theme through to icon
  let iconClasses = `fill-current  ${model.classes}`

  // Set size of icon
  switch (model.size) {
    case 'none':
      iconClasses += ''
      break
    case 'xs':
      iconClasses += ' h-3 w-3'
      break
    case 'sm':
      iconClasses += ' h-4 w-4'
      break
    default:
      iconClasses += ' h-6 w-6'
      break
  }

  return <ReactSVG src={model.icon} className={iconClasses} />
}

export default Icon
